import commonValidations from '@gef-ui/validations/validationFunctions';

commonValidations.isBirthNumber = 'isBirthNumber';
commonValidations.isRequired = 'isRequired'; // args: { messageKey = 'requiredField' }
commonValidations.isDate = 'isDate'; // args: { after = null, before = null }
commonValidations.isNumber = 'isNumber'; // args: { min = null, max = null }
commonValidations.isIc = 'isIc'; // No idea what this is...
commonValidations.hasOnlyDigits = 'hasOnlyDigits';
commonValidations.isString = 'isString'; // { minLength = null, maxLength = null, length = null }
commonValidations.isEmail = 'isEmail';
commonValidations.isCompanyName = 'isCompanyName';
commonValidations.isPhoneNumber = 'isPhoneNumber';
commonValidations.hasNoWhitespace = 'hasNoWhitespace';
commonValidations.isAlphanumerical = 'isAlphanumerical';

export default commonValidations;
